import { forwardRef } from 'react';

import type { Virtualizer } from '@tanstack/react-virtual';

import type { StoreItemVirtualRow } from './virtual-row/virtual-row';
import { VirtualRow } from './virtual-row/virtual-row';

interface StoreContentProps {
  virtualizer: Virtualizer<Window, Element>;
  rows: StoreItemVirtualRow[];
}
export const StoreContent = forwardRef<HTMLDivElement, StoreContentProps>(
  ({ virtualizer, rows }, listRef) => {
    const items = virtualizer.getVirtualItems();
    return (
      <div ref={listRef}>
        <div
          style={{
            height: `${virtualizer.getTotalSize()}px`,
            width: '100%',
            position: 'relative',
          }}
        >
          {items.map((virtualRow) => {
            return (
              <VirtualRow
                data={rows[virtualRow.index]}
                index={virtualRow.index}
                key={String(virtualRow.key)}
                ref={virtualizer.measureElement}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  transform: `translateY(${virtualRow.start - virtualizer.options.scrollMargin}px)`,
                }}
              />
            );
          })}
        </div>
      </div>
    );
  }
);

StoreContent.displayName = 'StoreContent';
